import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { useTranslation as u } from "react-i18next";
import e from "./mobile-header.module.less.js";
import { useState as d, useEffect as f } from "react";
import b from "../mobile-foldup-menu/mobile-foldup-menu.js";
import E from "../../../../../events/event-aggregator.js";
import "dayjs";
import N from "../../../../elements/link-wrapper/link-wrapper.js";
import "../../../../../contexts/global-context.js";
import "motion/react";
import "../../../../elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
const H = ({
  featureLinks: s,
  menuItems: a,
  mobileHeaderLinks: l,
  disableBoxShadowMobile: m = !1
}) => {
  const { t: r } = u(), [p, n] = d(!1);
  return f(() => {
    const t = E.subscribe("onRouteUpdate", () => {
      n(!1);
    });
    return () => {
      t.remove();
    };
  }, []), /* @__PURE__ */ i(
    "nav",
    {
      className: [e.wrapper, m ? e.disableBoxShadow : ""].join(" "),
      "aria-label": r("HEADER_MENU_MOBILE_ARIA_LABEL"),
      children: [
        l?.map((t, c) => /* @__PURE__ */ i(N, { url: t.url, className: `${e.menuButton} dynamicIcons`, children: [
          /* @__PURE__ */ o("span", { className: [e.icon, t.icon, "default"].join(" ") }),
          /* @__PURE__ */ o("span", { className: [e.icon, t.icon + "-filled", "currentPage hover"].join(" ") }),
          /* @__PURE__ */ o("div", { className: ["body-s mb-0", e.title].join(" "), children: t.title })
        ] }, c)),
        /* @__PURE__ */ i("button", { className: e.menuButton, onClick: () => n(!0), children: [
          /* @__PURE__ */ o("span", { className: [e.icon, "ui-icon-menu-bold"].join(" ") }),
          /* @__PURE__ */ o("div", { className: ["body-s mb-0", e.title].join(" "), children: r("HEADER_MENU") })
        ] }),
        /* @__PURE__ */ o(
          b,
          {
            featureLinks: s,
            menuItems: a,
            isOpen: p,
            onClickClose: () => {
              n(!1);
            },
            portalContainer: typeof document < "u" ? document.getElementById("mobile-menu-portal") : null
          }
        ),
        /* @__PURE__ */ o("div", { id: "mobile-menu-portal" })
      ]
    }
  );
};
export {
  H as default
};
